import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import * as React from 'react';

import ContactForm from '../../components/forms/ContactForm';
import { RequiredLabel } from '../../components/_mui';
import { IContactInfo } from '../../types/api';

const ContactFormContainer = () => {
  const form = useFormikContext<Partial<IContactInfo>>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <ContactForm title="Contact information" form={form} />
      <RequiredLabel />
    </Box>
  );
};

export default ContactFormContainer;
